import React from 'react';
import createEditor from '../../form/ComponentEditor';
import {StoreOrderEditor} from "./storeorderEditor";
import connect from "react-redux/es/connect/connect";
import Box from "../../layout/Box";

export class StoreOrderInEditor extends React.Component {
    render() {
        if (this.props.check === false || (this.props.till && this.props.till.pos && this.props.till.pos.location && this.props.till.pos.location.store && this.props.till.pos.location.store.id + "" === "" + this.props.till.pos.location.store.store)) {
            const componentProps = {...this.props};
            componentProps.filter = [...(componentProps.filter || []),...(this.props.check === false ? [] : [{field: "store", value: this.props.till.pos.location.store.id}, {field: "serviceprovider_type", value: "internal_store"}])];
            return <StoreOrderEditor {...componentProps} in={true}/>;
        } else {
            if (((this.props.till || {}).pos || {}).id) {
                return <Box header="Hiba" theme="danger">
                    Az eladás helye ({this.props.till.pos.name}) nem bevételezési raktár!
                </Box>;
            } else {
                return <Box header="Hiba" theme="danger">
                    Kérlek jelentkezz be egy eladási helyre!
                </Box>;
            }
        }
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    }
})(createEditor({
    componentName: "storeorder",
    WrappedComponent: StoreOrderInEditor,
    editor: "storeorderIn",
    props: {
        view: "admin",
        componentActions: (action, data, params) => {
            data = {...data};
            delete data.client;
            return {action,data,params};
        }
    }
}));
